module.exports = __webpack_public_path__ + "static/media/manage_accounts.7df20183.svg";